import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { StopDocument, documentsT } from "./types";
import api, { createDecoder } from "../../api";

const prefix = "/app/stops-documents";

export type State = Record<string, StopDocument[]>;

const initialState: State = {};

export const loadStopDocuments = createAsyncThunk(
  `${prefix}/load-stop-documents`,
  async (input: { stopId: string }, thunkApi) => {
    const { stopId } = input;
    return api(thunkApi).get({
      url: `/drivers-api/stops/${stopId}/documents`,
      decoder: createDecoder(documentsT),
    });
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadStopDocuments.pending, (state, action) => {
        state[action.meta.arg.stopId] = [];
      })
      .addCase(loadStopDocuments.fulfilled, (state, action) => {
        state[action.meta.arg.stopId] = action.payload;
      });
  },
});

export default slice.reducer;
